import { useState, useCallback } from 'react'
import api from '@/shared/lib/api'

interface CampaignProposal {
  subject_a: string
  subject_b: string
  email_body: string
  send_timing: string
  segment_advice: string
}

interface CampaignInput {
  business_name: string
  business_type: string
  current_rating: number
  target_rating: number
  segment_description: string
  recent_feedback_themes?: string[]
}

export function useAICampaign() {
  const [proposal, setProposal] = useState<CampaignProposal | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const propose = useCallback(async (input: CampaignInput) => {
    setIsLoading(true)
    setError(null)
    try {
      const { data } = await api.post('/ai/are-campaign', {
        business_name: input.business_name,
        business_type: input.business_type,
        current_rating: input.current_rating,
        target_rating: input.target_rating,
        segment_description: input.segment_description,
        recent_feedback_themes: input.recent_feedback_themes || [],
      })
      setProposal(data.data)
    } catch (err: any) {
      setError(err?.response?.data?.detail || 'Erreur lors de la génération.')
    } finally {
      setIsLoading(false)
    }
  }, [])

  const reset = useCallback(() => {
    setProposal(null)
    setError(null)
  }, [])

  return { propose, proposal, isLoading, error, reset }
}
